<template>
    <div class="video-container">
        <video
            v-if="!!media?.url"
            :poster="media.poster.thumbnail_url"
            controls
            controlslist="nofullscreen nodownload noplaybackrate"
            disablepictureinpicture
            preload="metadata"
            class="media-content"
            muted="muted"
            playsinline=""
            loop
            @loadedmetadata="loaded"
        >
            <source :src="media.url" type="video/mp4">
            <img
                :src="media.poster.full.url"
                :alt="`Full image`"
                class="fallback-image"
                ref="fallbackImage"
            >
            Your browser does not support video.
        </video>
        <div v-if="!isLoaded" class="loading">Loading...</div>
    </div>
</template>

<script>
import { defineComponent } from 'vue'
export default defineComponent({
    name: "VideoPlayer",
    props: {
        media: {
            type: [Object, Boolean],
            required: true,
            default: false
        }
    },
    data() {
        return {
            isLoaded: false
        }
    },
    methods: {
        loaded() {
            this.isLoaded = true;
        }
    }
})
</script>

<style scoped>

</style>